import styled, { keyframes } from "styled-components";

type Size = "s" | "m" | number;

interface Props {
	size?: Size;
	className?: string;
	text?: string;
}

const LoadingIndicator: React.FC<Props> = ({ size, text, className }) => {
	return (
		<StyledLoadingIndicator className={className} size={size || "m"}>
			<div className="indicator">
				<div className="bounce1" />
				<div className="bounce2" />
			</div>
			{text && <div className="loading-text">{text}</div>}
		</StyledLoadingIndicator>
	);
};

export default LoadingIndicator;

const StyledLoadingIndicator = styled.div<{ size: Size }>`
	.indicator {
		display: block;
		width: ${({ size }) => getSize(size)};
		height: ${({ size }) => getSize(size)};
		position: relative;
		margin: 0 auto;
	}

	.loading-text {
		font-size: ${(props) => props.theme.font.small};
		text-align: center;
	}

	.bounce1,
	.bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: #bbb;
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.bounce2 {
		animation-delay: -1s;
	}

	@-webkit-keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}

	@keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}
`;

function getSize(size: Size) {
	if (size === "s") return "20px";
	if (size === "m") return "40px";
	if (typeof size === "number") return size + "px";
	return "40px;";
}

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotatingSVG = styled.svg`
	width: 64px;
	height: 64px;
	fill: none;
	animation: ${rotateAnimation} 4s linear infinite;
`;

export const RotatingLoader = () => (
	<RotatingSVG viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M32 1C30.343 1 29 2.343 29 4V14C29 15.657 30.343 17 32 17C33.657 17 35 15.657 35 14V4C35 2.343 33.657 1 32 1Z"
			fill="#212121"
		/>
		<path
			opacity="0.9"
			d="M44.7285 22.2722C45.4965 22.2722 46.2645 21.9792 46.8495 21.3932L53.9205 14.3222C55.0925 13.1512 55.0925 11.2512 53.9205 10.0802C52.7495 8.90817 50.8495 8.90817 49.6785 10.0802L42.6075 17.1512C41.4355 18.3222 41.4355 20.2222 42.6075 21.3932C43.1925 21.9792 43.9605 22.2722 44.7285 22.2722Z"
			fill="#212121"
		/>
		<path
			opacity="0.8"
			d="M60 29H50C48.343 29 47 30.343 47 32C47 33.657 48.343 35 50 35H60C61.657 35 63 33.657 63 32C63 30.343 61.657 29 60 29Z"
			fill="#212121"
		/>
		<path
			opacity="0.7"
			d="M46.8505 42.6056C45.6785 41.4336 43.7785 41.4336 42.6075 42.6056C41.4355 43.7766 41.4355 45.6756 42.6075 46.8476L49.6785 53.9186C50.2645 54.5046 51.0325 54.7976 51.8005 54.7976C52.5685 54.7976 53.3365 54.5046 53.9215 53.9186C55.0935 52.7476 55.0935 50.8486 53.9215 49.6766L46.8505 42.6056Z"
			fill="#212121"
		/>
		<path
			opacity="0.6"
			d="M32 47C30.343 47 29 48.343 29 50V60C29 61.657 30.343 63 32 63C33.657 63 35 61.657 35 60V50C35 48.343 33.657 47 32 47Z"
			fill="#212121"
		/>
		<path
			opacity="0.5"
			d="M17.1504 42.6058L10.0794 49.6768C8.90842 50.8488 8.90842 52.7478 10.0794 53.9188C10.6644 54.5048 11.4334 54.7978 12.2004 54.7978C12.9674 54.7978 13.7364 54.5048 14.3224 53.9188L21.3934 46.8478C22.5644 45.6758 22.5644 43.7768 21.3934 42.6058C20.2224 41.4348 18.3224 41.4348 17.1504 42.6058Z"
			fill="#212121"
		/>
		<path
			opacity="0.4"
			d="M17 32C17 30.343 15.657 29 14 29H4C2.343 29 1 30.343 1 32C1 33.657 2.343 35 4 35H14C15.657 35 17 33.657 17 32Z"
			fill="#212121"
		/>
		<path
			opacity="0.3"
			d="M17.1512 21.3932C17.7362 21.9792 18.5052 22.2722 19.2722 22.2722C20.0392 22.2722 20.8082 21.9792 21.3932 21.3932C22.5652 20.2222 22.5652 18.3222 21.3932 17.1512L14.3222 10.0802C13.1512 8.90817 11.2512 8.90817 10.0802 10.0802C8.90817 11.2512 8.90817 13.1512 10.0802 14.3222L17.1512 21.3932Z"
			fill="#212121"
		/>
	</RotatingSVG>
);
